import {
	Directive,
	ElementRef,
	Input,
	OnInit,
	Renderer2,
	AfterViewInit
} from "@angular/core";
import { AppUtils } from "src/app/core/utils/app-utils";

@Directive({
	// tslint:disable-next-line: directive-selector
	selector: "[disableMKeyboard]"
})
export class DisableMKeyboardDirective implements OnInit, AfterViewInit {
	constructor(private el: ElementRef, private render: Renderer2) {}

	ngOnInit() {}

	ngAfterViewInit() {
		if (AppUtils.isMobileApp) {
			this.render.setAttribute(this.el.nativeElement, "readonly", "true");
		}
	}
}
